var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaylist = function SvgPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.917,
    d: "M10.426 19.735v1.942c0 .93-.626 1.742-1.524 1.979l-.434.114a1.7 1.7 0 0 1-.867-3.29zm0 0V11.96L19 9.666v7.765m0 0v1.952c0 .93-.626 1.742-1.525 1.98l-.436.114a1.7 1.7 0 0 1-.874-3.284zM3.667 1.666h18.667M1 7c0-.737.597-1.333 1.333-1.333h21.334C24.403 5.667 25 6.263 25 7v20c0 .736-.597 1.333-1.333 1.333H2.333A1.333 1.333 0 0 1 1 27z"
  })));
};
export default SvgPlaylist;